import React from 'react';
import { AdminRouteName } from '../../CONSTANTS';

import RepaymentTableRecords from '../RepaymentTableRecords';

const PaidRepayments = () => (
  <RepaymentTableRecords tabStatus="paid" defaultUrl={AdminRouteName.paidRepaymentRoute} toggleStorageId="paid-repayment-table-col" hasNameAndImage permissionName="can-view-paid-repayments" />
);
export default PaidRepayments;
